import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=dfb007ae&scoped=true"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"
import style0 from "./materialItem.vue?vue&type=style&index=0&id=dfb007ae&prod&lang=scss&scoped=true"
import style1 from "./materialItem.vue?vue&type=style&index=1&id=dfb007ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb007ae",
  null
  
)

export default component.exports